import { useAppActions } from 'reducers/slices/auth/emailConfirmationSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { resendEmailConfirmation } = useAppActions();
  const { emailConfirmationResendingStatus } = useSelector(state => state.authEmailConfirmationSlice);

  return {
    resendEmailConfirmation,
    isEmailConfirmationResending: useFetchStatus(emailConfirmationResendingStatus).isPending,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/auth/useEmailConfirmation.js